module.exports = require("./hi.js");